import React from 'react';
import PropTypes from 'prop-types';

import CheckboxFilterPanel from './CheckboxFilterPanel';
import questionFilterPanelType from './questionFilterPanelType';
import toStringFilterValue from './toStringFilterValue';
import { merge, range } from 'lodash';

const withOneToFiveFilters = props =>
  merge(
    {},
    props,
    {
      question: {
        options: range(5).map(n => (n + 1).toString()).map(choice => ({
          id: choice,
          display: choice
        }))
      }
    });

const withStringValues = toStringFilterValue({fromStringValue: numberString => parseInt(numberString, 10)});

export const OneToFiveFilterPanel = props =>
  <CheckboxFilterPanel {...withStringValues(withOneToFiveFilters(props))} />;

OneToFiveFilterPanel.defaultProps = {
  value: []
};

OneToFiveFilterPanel.propTypes = merge({
  value: PropTypes.arrayOf(PropTypes.number).isRequired
}, questionFilterPanelType);

export default OneToFiveFilterPanel;
